export default __webpack_public_path__ + "static/media/hash.0ff12c72.svg";